import { humanLowerCaseToId } from '~/misc/equipment';
import { setDeeplink } from '~/misc/getQuery';
import deeplink from '~/misc/deeplink';
import moment from 'moment';
export const platformParser = (ua = window.navigator.userAgent) =>  {
  if(/(iPhone|iPad|iPod|iOS)/i.test(ua)) return "Ios";
  if(/(Android|Adr)/i.test(ua)) return "Android";
  return "Pc";
};

const ObjectToQuery = (obj) => {
  const query = Object.entries(obj).filter(([key,value])=> value&&value.length).reduce((acc,cur)=>{
    const [key,value] = cur;
    return `${acc}${key}=${value}&`
  },'?')
  return query.substring(0, query.length-1)
}


/**
 * return start day and next 2 days, if start time is past, use today instead
 * @param {*} param0 { start } start time string like 2022-02-20T16:00:00
 * @returns {Aarry} day and next 2 days
 */
const timeParser = ({ start }) => { 
  const day = moment(start.replace(/T.*/, ''));
  const today = moment();
  const startTime = today.isAfter(day) ? today : day
  const formatScheme = 'YYYY-MM-DD'
  return [
    startTime.format(formatScheme),
    startTime.add(1, 'days').format(formatScheme),
    startTime.add(1, 'days').format(formatScheme),
  ] 
}

const arrToqueryString = (arr,queryname) => {
  if (arr.length === 0) return ''
  return arr.reduce((acc,cur)=>{
    return acc+'&'+queryname+'='+cur
  },'')
}

const weightMap = {
  'any': {
    min: "-1",
    max: "-1"
  }, 
  'min': {
    min:"-1",
    max: 26000,
  },
  "upperMin": { 
    min: 26001,
    max: 33000,
  },
  "middle": {
    min: 33001,
    max: 40000,
  },
  "max": { 
    min: 40001,
    max: "-1"
  }
}

export const mobileSearchBuiler = ({
  equipment,
  pickUpDate,
  dropOffDate,
  pickLat,
  pickLng,
  pickCity,
  pickState,
  pickDeadHead,
  dropLat,
  dropLng,
  dropCity,
  dropState,
  dropDeadHead,
  loadSize,
  weight, // min/upperMin/middle/max
  length,
}) => {

  const [pickupTime, __ , dropoffTime] = timeParser({
    start: pickUpDate
  })

  const { min, max } = weight ? weightMap[weight] : weightMap['any']
  const queryObj = {
    pickUpDate: `${pickupTime}T00:00:00`,
    dropOffDate: `${dropoffTime}T23:59:59`,
    pickLat: pickLat ? String(pickLat) : null,
    pickLng: pickLng ? String(pickLng) : null,
    pickAddress: pickCity ? `${pickCity},_${pickState}` : null,
    pickDeadHead: pickDeadHead ? String(pickDeadHead) : null,
    dropLat: dropLat ? String(dropLat) : null,
    dropLng: dropLng ? String(dropLng) : null,
    dropAddress: dropCity ? `${dropCity},_${dropState}` : null,
    dropDeadHead: dropDeadHead ? String(dropDeadHead) : null,
    tripLength: 'any',
    loadSize,
    weight_Min: min ? String(min) : null,
    weight_Max: max ? String(max) : null,
    weight_null: true,
    length: length ? String(length) : null,
    length_null: true,
    sort: "Time_Posted_Newest_first"
  }
  return ObjectToQuery(queryObj) + (equipment && equipment.length
  ? arrToqueryString(
    equipment.split(",").map((e) => e.split(' ').map(word=> word.replace(/^\S/, s => s.toUpperCase())).join(' ')),
      "type"
    )
  : '')
} 

export const  webSearchBuilder = ({
  equipment,
  pickUpDate,
  dropOffDate,
  pickLat,
  pickLng,
  pickCity,
  pickState,
  pickDeadHead,
  dropLat,
  dropLng,
  dropCity,
  dropState,
  dropDeadHead,
  loadSize,
  weight,
  length,
}) => {
  const query = {
    dhd: dropDeadHead,
    dho: pickDeadHead,
    emptyLength: true,
    emptyWeight: true,
    from_city: pickCity,
    from_country: 'US',
    from_lat: pickLat,
    from_lng: pickLng,
    from_name: `${pickCity}, ${pickState}`,
    from_state: pickState,
    limit: 50,
    loadSize,
    offset: "0",
    show_option: "All",
    sort_by: "age",
    sort_order: "asc",
    to_city: dropCity,
    to_country: 'US',
    to_lat: dropLat,
    to_lng:dropLng,
    to_name: `${dropCity}, ${dropState}`,
    to_state: dropState,
    weight,
    length,
  }
  const dateQuery = arrToqueryString(timeParser({
    start:pickUpDate,
    end: dropOffDate,
  }), "date")
  const equipmentQuery =
    equipment && equipment.length
      ? arrToqueryString(
        equipment.split(",").map((e) => humanLowerCaseToId[e]),
          "equipment"
        )
      : "";
  return ObjectToQuery(query) + `${dateQuery}` + `${equipmentQuery}`
}



export const web = {
  gotoDetail: ({campaignLoadId, campaignQuery, loginToken,  autoAction , isMobile }) => {
    window.location.href = `/loads/${campaignLoadId}?loadSearchQuery=${campaignQuery}&token=${loginToken}${autoAction? ("&autoAction="+ autoAction) : ""}${isMobile? ("&isMobile="+ isMobile) : ""}`;
  },
  gotoSearch: ({campaignQueryObj,loginToken, isMobile }) => {
    window.location.href = `/searchloads?${webSearchBuilder(campaignQueryObj)}&token=${loginToken}${isMobile? ("&isMobile="+ isMobile) : ""}`;
  },
  gotoPostTruck: ({loginToken, campaignQuery, isMobile }) => {
    window.location.href = `/post-truck?token=${loginToken}&campaignQuery=${campaignQuery}${isMobile? ("&isMobile="+ isMobile) : ""}`;
  },
  gotoMemberShip: ({loginToken, isMobile }) => {
    window.location.href = `/info/rate-inspection?token=${loginToken}${isMobile? ("&isMobile="+ isMobile) : ""}`;
  },
  gotoCapacityRatio: ({loginToken, isMobile}) => {
    window.location.href = `/capacity-ratio?token=${loginToken}${isMobile? ("&isMobile="+ isMobile) : ""}`
  },
  gotoCapacityIndicator: ({loginToken, isMobile}) => {
    window.location.href = `/capacity-ratio-map-list?token=${loginToken}${isMobile? ("&isMobile="+ isMobile) : ""}`
  }
}

export const Android = {
  gotoDetail: ({campaignLoadId, campaignQuery, loginToken,  autoAction}) => {
    web.gotoDetail({campaignLoadId, campaignQuery, loginToken,  autoAction ,isMobile: true})
  },
  gotoSearch: ({campaignQueryObj,loginToken}) => {
    const id = deeplink.setSearch(campaignQueryObj);
    web.gotoSearch({campaignQueryObj ,loginToken, isMobile: id});
  },
  gotoPostTruck: ({loginToken, campaignQuery, campaignQueryObj}) => {
    const id = deeplink.setPostTruck(campaignQueryObj);
    web.gotoPostTruck({loginToken, campaignQuery ,isMobile: id});
  },
  gotoMemberShip: ({loginToken, campaignQueryObj}) => {
    const id = deeplink.setRateCheck(campaignQueryObj);
    web.gotoMemberShip({loginToken, isMobile: id});
  },
  gotoCapacityRatio: ({loginToken, campaignQueryObj}) => {
    const id = deeplink.setCapacityRatio(campaignQueryObj);
    web.gotoCapacityRatio({loginToken, isMobile: id})
  },
  gotoCapacityIndicator: ({loginToken, campaignQueryObj}) => {
    const id = deeplink.setCapacityIndicator(campaignQueryObj);
    web.gotoCapacityIndicator({loginToken, isMobile: id})
  }
}

export const Ios = {
  gotoDetail: ({campaignLoadId, campaignQuery, loginToken,  autoAction}) => {
    web.gotoDetail({campaignLoadId, campaignQuery, loginToken,  autoAction ,isMobile: true})
  },
  gotoSearch: ({campaignQueryObj,loginToken}) => {
    let id = ''
    //NOTICE: Ios app can not handle geo lost
    if(!campaignQueryObj.pickLat || !campaignQueryObj.pickLng) {
      id = setDeeplink( `truckloads://Loadlist_filter`);
    }else { 
      id = deeplink.setSearch(campaignQueryObj);
    }
    web.gotoSearch({campaignQueryObj ,loginToken, isMobile: id})
  },
  gotoPostTruck: ({loginToken, campaignQuery, campaignQueryObj}) => {
    const id = deeplink.setPostTruck(campaignQueryObj);
    web.gotoPostTruck({loginToken, campaignQuery ,isMobile: id})
  },
  gotoMemberShip: ({loginToken, campaignQueryObj}) => {
    const id = deeplink.setRateCheck(campaignQueryObj);
    web.gotoMemberShip({loginToken, isMobile: id});
  },
  gotoCapacityRatio: ({loginToken, campaignQueryObj}) => {
    const id = deeplink.setCapacityRatio(campaignQueryObj);
    web.gotoCapacityRatio({loginToken, isMobile: id})
  },
  gotoCapacityIndicator: ({loginToken, campaignQueryObj}) => {
    const id = deeplink.setCapacityIndicator(campaignQueryObj);
    web.gotoCapacityIndicator({loginToken, isMobile: id})
  }
}
export const jumper = () => {
  const platform = platformParser();
  if(platform  === 'Android') {
    return Android
  }else if(platform  === 'Ios'){
    return Ios
  }
  return web;
}



// WEBPACK FOOTER //
// ./src/pages/EmailCampaignNew/uilts.js